import styled from 'styled-components'

const EventItemStyle = styled.div`
	--imageWidth: 27vw;
	--leftWrapPadTB: var(--sp8x);
	--leftWrapPadLR: var(--sp8x);
	--eventCatPadTB: var(--sp1-5x);
	--eventCatPadLR: var(--sp4x);
	--eventCatDistance: var(--sp2x);
	--iconDistance: var(--sp3x);
	--titleMaxWidth: var(--sp116x);
	--titleMTop: var(--sp5x);
	--datePadTB: var(--sp1-5x);
	--datePadLR: var(--sp3x);

	.event-inner-item {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		overflow: hidden;
		border-radius: var(--radiusM);

		.left-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			flex: 1;
			background-color: var(--bgGray);
			padding: var(--leftWrapPadTB) var(--leftWrapPadLR);
			transition: background-color var(--trTime);

			.top-inner-cont {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				margin-bottom: calc(-1 * var(--eventCatDistance));

				.event-categories {
					display: flex;
					align-items: center;
					margin: 0 calc(-1 * calc(var(--eventCatDistance) / 2));
					margin-bottom: var(--eventCatDistance);

					.event-cat {
						padding: var(--eventCatPadTB) var(--eventCatPadLR);
						background-color: var(--white);
						border-radius: var(--sp15x);
						margin: 0 calc(var(--eventCatDistance) / 2);
					}
				}

				.location-wrapper {
					display: flex;
					align-items: center;
					margin-bottom: var(--eventCatDistance);

					.location {
						margin: 0 var(--iconDistance);
						transition: color var(--trTime);
					}
				}
			}

			.title {
				max-width: var(--titleMaxWidth);
				margin-top: var(--titleMTop);
				transition: color var(--trTime);
			}

			.date {
				width: fit-content;
				padding: var(--datePadTB) var(--datePadLR);
				background-color: var(--chromeGreen);
				border-radius: var(--sp1-5x);
				margin-top: var(--titleMTop);
				transition: background-color var(--trTime);
			}

			.place-icon {
				.path1,
				.path11,
				.path12,
				.path13 {
					&:before {
						transition: color var(--trTime);
					}
				}

				.path2,
				.path3,
				.path4,
				.path5,
				.path6,
				.path7,
				.path8,
				.path9,
				.path10 {
					&:before {
						transition: color var(--trTime);
					}
				}
			}
		}

		.right-wrapper {
			width: var(--imageWidth);

			.image-cont {
				--proportion: 77.4%;

				height: 100%;
			}
		}
	}

	.event-link {
		@media (hover: hover) {
			&:hover {
				.event-inner-item .left-wrapper {
					background-color: var(--red100);

					.title,
					.top-inner-cont .location-wrapper .location {
						color: var(--white);
					}

					.date {
						background-color: var(--white);
					}

					.place-icon {
						.path1,
						.path11,
						.path12,
						.path13 {
							&:before {
								color: var(--white);
							}
						}

						.path2,
						.path3,
						.path4,
						.path5,
						.path6,
						.path7,
						.path8,
						.path9,
						.path10 {
							&:before {
								color: var(--red100);
							}
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--imageWidth: 27.24vw;
		--leftWrapPadTB: var(--sp6x);
		--leftWrapPadLR: var(--sp6x);
		--eventCatPadTB: var(--sp1x);
		--eventCatPadLR: var(--sp3x);
		--eventCatDistance: var(--sp1-5x);
		--iconDistance: var(--sp2x);
		--titleMaxWidth: var(--sp87x);
		--titleMTop: var(--sp4x);
		--datePadTB: var(--sp1x);
		--datePadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--imageWidth: 30.19vw;
		--leftWrapPadTB: var(--sp6x);
		--leftWrapPadLR: var(--sp6x);
		--eventCatPadTB: var(--sp1x);
		--eventCatPadLR: var(--sp3x);
		--eventCatDistance: var(--sp1x);
		--iconDistance: var(--sp2x);
		--titleMaxWidth: var(--sp76x);
		--titleMTop: var(--sp4x);
		--datePadTB: var(--sp1x);
		--datePadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--imageWidth: 28.13vw;
		--leftWrapPadTB: var(--sp5x);
		--leftWrapPadLR: var(--sp5x);
		--eventCatPadTB: var(--sp1x);
		--eventCatPadLR: var(--sp3x);
		--eventCatDistance: var(--sp1x);
		--iconDistance: var(--sp2x);
		--titleMaxWidth: var(--sp76x);
		--titleMTop: var(--sp4x);
		--datePadTB: var(--sp1x);
		--datePadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--imageWidth: 30.63vw;
		--leftWrapPadTB: var(--sp5x);
		--leftWrapPadLR: var(--sp5x);
		--eventCatPadTB: var(--sp0-5x);
		--eventCatPadLR: var(--sp2x);
		--eventCatDistance: var(--sp1x);
		--iconDistance: var(--sp2x);
		--titleMaxWidth: var(--sp65x);
		--titleMTop: var(--sp4x);
		--datePadTB: var(--sp1x);
		--datePadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--imageWidth: 30.97vw;
		--leftWrapPadTB: var(--sp4x);
		--leftWrapPadLR: var(--sp4x);
		--eventCatPadTB: var(--sp0-5x);
		--eventCatPadLR: var(--sp2x);
		--eventCatDistance: var(--sp1x);
		--iconDistance: var(--sp1-5x);
		--titleMaxWidth: 100%;
		--titleMTop: var(--sp2x);
		--datePadTB: var(--sp1x);
		--datePadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--imageWidth: 38vw;
		--leftWrapPadTB: var(--sp3x);
		--leftWrapPadLR: var(--sp3x);
		--eventCatPadTB: var(--sp0-5x);
		--eventCatPadLR: var(--sp2x);
		--eventCatDistance: var(--sp1x);
		--iconDistance: var(--sp1-5x);
		--titleMaxWidth: 100%;
		--titleMTop: var(--sp2x);
		--datePadTB: var(--sp1x);
		--datePadLR: var(--sp2x);

		.event-inner-item .left-wrapper .date {
			--titleMTop: var(--sp4x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--imageWidth: 100%;
		--leftWrapPadTB: var(--sp4x);
		--leftWrapPadLR: var(--sp3x);
		--eventCatPadTB: var(--sp0-5x);
		--eventCatPadLR: var(--sp2x);
		--eventCatDistance: var(--sp1x);
		--iconDistance: var(--sp1-5x);
		--titleMaxWidth: 100%;
		--titleMTop: var(--sp2x);
		--datePadTB: var(--sp1x);
		--datePadLR: var(--sp2x);

		.event-inner-item {
			.left-wrapper {
				width: 100%;
				flex: unset;

				.date {
					--titleMTop: var(--sp3x);
				}
			}

			.right-wrapper .image-cont {
				--proportion: 52.4%;
			}
		}
	}
`

export default EventItemStyle
